import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faUnderline } from '@fortawesome/pro-light-svg-icons';

export type ProLightUnderlineProps = IconComponentProps;

export const ProLightUnderline = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightUnderlineProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faUnderline}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faUnderline}
    />
  );
};

ProLightUnderline.displayName = 'ProLightUnderline';
